/* unplugin-vue-components disabled */import __unplugin_components_0 from '/app/src/components/core/virtualDevice/driver/list.vue';
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(__unplugin_components_0)}
var staticRenderFns = []

export { render, staticRenderFns }